import React, { useContext, useState } from 'react'
import AuthContext from '../../context/auth/authContext'
import SubmitForm from './SubmitForm'
import RateCard from '../RateCard';
import { forEach } from 'lodash';

import ProductSlider from './ProductSlider';

function Step10() {

    const authContext = useContext(AuthContext);
    let { lp, lead, gotoNextStep, step } = authContext;


    const handleSubmit = (event) => {
        event.preventDefault();
        gotoNextStep([], step);

    }
    let thisProd;
    let thisProdType;
    let thisProdOption;
    lp.products.forEach((item) => {
        let $match = item.types.find(x => x.id === lead.offer.product_type_id);
        if ($match) {
            thisProdType = $match;
        }
        if (item.id === lead.offer.product_id) {
            thisProd = item;
        }
    });

    let $match = thisProd.options.find(x => x.id === lead.offer.product_option_id);
    if ($match) {
        thisProdOption = $match;
    }
    const getExtras = () => {
        if (!lead.offer.extras_json) {
            return [];
        }
        // console.log($type);
        let $xtraArr = [];
        thisProdType.extras.forEach(element => {
            let $isChosen = lead.offer.extras_json.find(x => x.id === element.id);
            if ($isChosen) {
                let $item = {
                    id: element.id,
                    name: element.name,
                    price: element.price.toFixed(2),
                    qty: $isChosen.qty
                }
                $xtraArr.push($item);
            }

        });


        return $xtraArr;
    }
    const initialState = {
        product: thisProd.name,
        version: thisProdOption ? thisProdOption.name : '',
        option: `${thisProdType.name} - $${thisProdType.discount_price ? thisProdType.discount_price.toFixed(2) : thisProdType.price.toFixed(2)}`,
        extras: getExtras()
    }
    var settings = {
        dots: false,
        infinite: true,
        arrows: false,
        autoplaySpeed: 5000,
        speed: 500,
        autoplay: true,
        slidesToShow: 1,
        slidesToScroll: 1
    };
    const [fields, setFields] = useState(initialState);
    // console.log(fields, thisProdType);
    return (
        <>
            <form onSubmit={e => handleSubmit(e)}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="box_product">
                                <div className="slider-box">
                                    <ProductSlider product={thisProd.id} settings={settings} />
                                </div>
                                <div className="inner-title">
                                    <h2 className="text-center text-md-left">What you get with <span className="prod_name">{fields.product} <small>{fields.version} version</small></span></h2>
                                    <div className="extras">
                                        <h6 className="badge badge-info info">{fields.option} </h6>
                                        <ul>
                                            {fields.extras ? fields.extras.map((extra, index) => {
                                                return (
                                                    <li key={extra.id}><i className="fas fa-check-circle" style={{ color: '#87d601' }}></i> {extra.name} - ${extra.price} <small>x{extra.qty} quantity</small></li>
                                                )
                                            }) : ''}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12">
                            {lp.enable_rate_card_summary ? <>
                                <RateCard carditems={thisProd.ratecarditems} />
                            </> : ''}
                        </div>

                    </div>
                    <SubmitForm />
                </div >

            </form >
        </>
    )
}

export default Step10
